import $ from "../$.js"

var $animation_elements = $('.animation-element, .dark-outof-view, body>*');
var $window = $(window);

$.fn.loadImage = function(){
  this.find('img[data-src]:visible').each(function (idx,img){
    img = $(img);
    img.attr('src',img.attr('data-src'));
    img.removeAttr('data-src')
  });
}

function check_if_in_view() {
  $('body').toggleClass('scrolled',$(document).scrollTop()>60);
  
  var window_height = $window.height();
  var window_top_position = $window.scrollTop();
  var window_bottom_position = window_top_position + window_height;
  $.each($animation_elements, function () {
     var $element = $(this);
     var element_height = $element.outerHeight();
     var element_top_position = $element.offset().top;
     var element_bottom_position = element_top_position + element_height;
     if (element_bottom_position >= window_top_position && element_top_position < window_bottom_position) {
        $element.addClass('in-view');
     if ($element.hasClass('only-once'))
       $('.circle').fadeIn(3000);
    }
    else if(!$element.hasClass('only-once')) {
      $element.removeClass('in-view');
    }
    $element.toggleClass('before-view',element_bottom_position < window_top_position+window_height/4);
    $element.toggleClass('after-view',element_top_position > window_top_position+3* window_height/4);
  });
  
  $('body>.before-view').last().loadImage()
  $('body>.in-view').loadImage()
  $('body>.after-view').first().loadImage()
}
 $window.on('scroll resize', check_if_in_view);
 $window.trigger('scroll');

 
 